<template>
    <div class="notes-comment" v-html="normalizedText" />
</template>

<script>
function replaceLinks(text) {
    return (text || '').replace(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi, function(
        _,
        space,
        url
    ) {
        let link = url;
        if (!link.match('^https?://')) {
            link = 'http://' + link;
        }
        return space + '<a class="link" target="_blank" href="' + link + '">' + url + '</a>';
    });
}

export default {
    name: 'NotesComment',
    props: {
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        normalizedText() {
            return replaceLinks(this.text);
        }
    }
};
</script>

<style src="./NotesComment.scss" lang="scss"></style>
